import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5acb0206"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-token" }
const _hoisted_2 = { class: "m-token-name" }
const _hoisted_3 = { class: "m-token-contract-address" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " / ", -1))
const _hoisted_5 = { class: "m-token-token-id" }
const _hoisted_6 = {
  key: 0,
  href: "https://delegate.cash/",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lazy_image = _resolveComponent("lazy-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_ctx.token.image)
        ? (_openBlock(), _createBlock(_component_lazy_image, {
            key: 0,
            src: _ctx.token.image
          }, null, 8, ["src"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.token.name), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.token.contractAddress), 1),
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.token.tokenId), 1),
      (_ctx.token.eip5131 || _ctx.token.eip5639 || _ctx.token.delegateAddress === _ctx.connectedWalletAddress)
        ? (_openBlock(), _createElementBlock("a", _hoisted_6, [
            _createElementVNode("img", {
              class: "m-token-delegate-cash-icon",
              src: _ctx.delegateCashIcon
            }, null, 8, _hoisted_7)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.cta)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickHandler(_ctx.token)))
        }, _toDisplayString(_ctx.cta), 1))
      : _createCommentVNode("", true)
  ]))
}